/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `CELINA` - CELINA
 * * `LIVEKIT` - LIVEKIT
 * @export
 */
export const VoiceAgentProtocolEnum = {
  celina: 'CELINA',
  livekit: 'LIVEKIT',
} as const;
export type VoiceAgentProtocolEnum = (typeof VoiceAgentProtocolEnum)[keyof typeof VoiceAgentProtocolEnum];

export function instanceOfVoiceAgentProtocolEnum(value: any): boolean {
  for (const key in VoiceAgentProtocolEnum) {
    if (Object.prototype.hasOwnProperty.call(VoiceAgentProtocolEnum, key)) {
      if ((VoiceAgentProtocolEnum as Record<string, VoiceAgentProtocolEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function VoiceAgentProtocolEnumFromJSON(json: any): VoiceAgentProtocolEnum {
  return VoiceAgentProtocolEnumFromJSONTyped(json, false);
}

export function VoiceAgentProtocolEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoiceAgentProtocolEnum {
  return json as VoiceAgentProtocolEnum;
}

export function VoiceAgentProtocolEnumToJSON(value?: VoiceAgentProtocolEnum | null): any {
  return value as any;
}
